// extracted by mini-css-extract-plugin
export default {"messageContainer":"_1eL_ffLcnNxt-90VcEYT8l","label":"_2zRGkdt6eG3IRE8LHz58sV"};